export default __webpack_public_path__ + "static/media/circle_lock.eba04fcc.svg";